import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';

import { LoadingProgrammatic as Loading } from 'buefy';

import store from '@/store';
import { GET_TOKEN, GET_AUTHENTICATED } from '@/store/modules/auth/types';
import { GET_VIDEO_STORE } from '../store/modules/video/types';

import { http, httpRefreshToken } from '@/services/http';

import { pathParser } from '@/utils/pathParser';

import { Component } from 'vue-property-decorator';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: { title: '' },
  },
  {
    path: '/support/:group?/:topic?',
    name: 'support',
    component: () =>
      import(/* webpackChunkName: "support" */ '../views/Support.vue'),
    meta: { title: 'Support' },
  },
  {
    path: '/terms',
    name: 'terms',
    component: () =>
      import(/* webpackChunkName: "terms" */ '../views/Terms.vue'),
    meta: { title: 'Terms of Service' },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () =>
      import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue'),
    meta: { title: 'Privacy Policy' },
  },
  {
    path: '/video',
    name: 'video_main',
    meta: { title: 'Video' },
    beforeEnter: async (to: any, from: any, next: any) => {
      const video = store.getters[`video/${GET_VIDEO_STORE}`];

      if (store.getters[`video/${GET_VIDEO_STORE}`]) {
        let pathMatch = video.data;

        if (video.type === 'id') {
          pathMatch = '';
        }

        next({
          name: 'video',
          params: {
            type: video.type,
            id: video.id,
            pathMatch,
          },
          query: video.query,
        });
      } else {
        next({
          name: 'home',
        });
      }
    },
  },
  {
    path: '/video/:type/:id/(.*)?',
    name: 'video',
    meta: { title: 'Video' },
    beforeEnter: async (to: any, from: any, next: any) => {
      if (to.params.type === 'id' && !to.params._type) {
        const loading = Loading.open({
          container: null,
        });
        try {
          if (
            store.getters[`auth/${GET_AUTHENTICATED}`] &&
            !store.getters[`auth/${GET_TOKEN}`]
          ) {
            try {
              await httpRefreshToken();
              // eslint-disable-next-line no-empty
            } catch (e) {}
          }

          const response = await http.get(`/video/${to.params.id}`);
          if (response.status === 200) {
            let query = to.query;
            if (
              Object.keys(query).length === 0 &&
              query.constructor === Object
            ) {
              query = response.data.params;
            }

            loading.close();
            next({
              name: 'video',
              params: {
                type: 'id',
                id: to.params.id,
                pathMatch: '',
                _authorized: response.data.authorized,
                _type: response.data.video.type,
                _id: response.data.video.id,
                _pathMatch: response.data.data,
              },
              query,
            });
          } else {
            loading.close();
            next({
              name: 'error',
              params: { code: 404, redirectedFrom: 'video' },
            });
          }
        } catch (e) {
          if (e.response.status === 404) {
            loading.close();
            next({
              name: 'error',
              params: { code: 404, redirectedFrom: 'video' },
              redirectedFrom: true,
            });
          } else {
            loading.close();
            next({
              name: 'error',
              params: { code: 500, redirectedFrom: 'video' },
            });
          }
        }
      } else {
        next();
      }
    },
    component: () =>
      import(/* webpackChunkName: "video" */ '../views/Video.vue'),
  },
  {
    path: '/error/:code',
    name: 'error',
    meta: { title: 'Error' },
    beforeEnter: (to: any, from: any, next: any) => {
      if (to.redirectedFrom || to.params.redirectedFrom) {
        next(true);
      } else {
        next({
          name: 'home',
        });
      }
    },
    component: () =>
      import(/* webpackChunkName: "error" */ '../views/Error.vue'),
  },
  {
    path: '*',
    redirect: (to: any) => {
      return pathParser(to);
    },
  },
];

Component.registerHooks(['beforeRouteLeave']);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to, from) => {
  let title = process.env.VUE_APP_NAME;

  if (to.meta.title) {
    title = `${to.meta.title} | ${title}`;
  }

  document.title = title;
});

export default router;
